import React from 'react'
import PropTypes from 'prop-types'

const Avatar = ({ width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.7031 18.0094C16.8333 14.5 12 14.5 12 14.5C12 14.5 6.83325 14.5 5.29688 18.0094C6.94688 19.8469 9.3375 21 12 21C14.6625 21 17.0531 19.8422 18.7031 18.0094ZM24 12C24 18.6281 18.6281 24 12 24C5.37188 24 0 18.6281 0 12C0 5.37188 5.37188 0 12 0C18.6281 0 24 5.37188 24 12ZM12 12C13.8656 12 15.375 10.2406 15.375 8.375C15.375 6.50938 13.8656 4.68853 12 4.68853C10.1344 4.68853 8.625 6.50938 8.625 8.375C8.625 10.2406 10.1344 12 12 12Z" fill="#F6F6F6" />
  </svg>

)

Avatar.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}

Avatar.defaultProps = {
  width: 24,
  height: 24,
}

export default Avatar
